import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';

import {State} from 'src/app/store';
import * as actions from '../../../../store/auth/authentication.actions';
import * as selectors from '../../../../store/auth/authentication.selectors';
import * as selectorsApp from '../../../../store/app/app.selectors';
import {selectAppViewPort} from '../../../../store/app/app.selectors';

@Component({
  selector: 'app-resend-verification-email',
  templateUrl: './resend-verification-email.component.html',
  styleUrls: ['./resend-verification-email.component.scss'],
})
export class ResendVerificationEmailComponent implements OnInit, OnDestroy, AfterViewChecked {
  resend_verification_email_form: FormGroup;
  resend_verification_email_spinner = false;
  error_message = '';
  platformBrandLogo = '';
  platformName = '';
  platformLandingPage = '';
  viewport = '';

  private subscriptions = [];

  constructor(public store: Store<State>,
              private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.store.select(selectAppViewPort).subscribe(result => {
      this.viewport = result;
    });
    this.resend_verification_email_form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(
          "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$"
        ),
      ]),
    });

    this.subscriptions.push(
      this.store
        .select(selectors.selectResendVerificationEmailError)
        .subscribe(errMessage => {
          this.error_message = errMessage;
        }),
      this.store
        .select(selectors.selectResendVerificationEmailLoading)
        .subscribe(loading => {
          this.resend_verification_email_spinner = loading;
        }),
    );
  }

  ngAfterViewChecked() {
    this.subscriptions.push(
        this.store.select(selectorsApp.selectUserGroup).subscribe(userGroup => {
          if (userGroup !== null ) {
            this.platformBrandLogo = userGroup.logo_login_url;
            this.platformName = userGroup.platform_name;
            this.platformLandingPage = userGroup.landing_page;
            this.cdr.detectChanges();
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.store.dispatch(actions.clearErrors());
  }

  resendVerificationEmail(): void {
    if (this.resend_verification_email_form.status !== 'INVALID') {
      this.store.dispatch(
        actions.resendVerificationEmail({
          email: this.resend_verification_email_form.value.email,
        })
      );
    }
  }
}
